// extracted by mini-css-extract-plugin
export default {"lottieContainer":"noResultsMatched_lottieContainer__UuBex","noResults":"noResultsMatched_noResults__g8MVG"};